import { z } from "zod";

const introSchema = z.object({
  greeting: z.string().min(1, "Greeting is required").max(500),
  rotatingTitles: z.array(z.string().max(500)).min(1).max(20),
  bio: z.string().max(15000).optional(),
  imageSrc: z.string().max(2000).optional(),
});

const experienceItemSchema = z.object({
  id: z.string().max(24).optional(),
  title: z.string().min(1, "Title is required").max(500),
  subtitle: z.string().max(2000).optional(),
  year: z.string().max(200).optional(),
  src: z.string().max(2000).optional(),
  listItems: z.array(z.string().max(10000)).max(200),
});

const educationItemSchema = z.object({
  id: z.string().max(24).optional(),
  title: z.string().min(1, "Title is required").max(500),
  subtitle: z.string().max(2000).optional(),
  year: z.string().max(200).optional(),
  src: z.string().max(2000).optional(),
});

export const profileFormSchema = z.object({
  intro: introSchema,
  expDetails: z.array(experienceItemSchema).max(100),
  eduDetails: z.array(educationItemSchema).max(50),
});
